var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "url(#paint0_linear_5570_45698)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4855 29.7412L32.6878 21.4175C34.6821 20.5505 41.4451 17.7759 41.4451 17.7759C41.4451 17.7759 44.5664 16.562 44.3063 19.51C44.2196 20.7239 43.526 24.9724 42.8323 29.5678L40.6647 43.1805C40.6647 43.1805 40.4913 45.1747 39.0173 45.5216C37.5433 45.8684 35.1156 44.3077 34.6821 43.9609C34.3352 43.7008 28.1792 39.799 25.9248 37.8915C25.3179 37.3713 24.6243 36.3308 26.0115 35.1169C29.1329 32.2557 32.8612 28.7008 35.1156 26.4464C36.156 25.406 37.1965 22.9782 32.8612 25.9262L20.6358 34.1632C20.6358 34.1632 19.2485 35.0302 16.6474 34.2499C14.0462 33.4695 11.0115 32.4291 11.0115 32.4291C11.0115 32.4291 8.93061 31.1285 12.4855 29.7412Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5570_45698",
    x1: 40.0023,
    y1: 10.0023,
    x2: 25.0023,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.af41bde37d6f7e28b4207e4e78b9079f.svg";
export { ForwardRef as ReactComponent };